import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function RegisterRoute(props) {
  const navigate = useNavigate();
  const checkRegisteration = () => {
  const isRegisterDone = localStorage.getItem('isRegisterDone');
  const isAdmin = localStorage.getItem('isAdmin');
    if ((isRegisterDone == 0 || isRegisterDone === 'undefined') && (isAdmin == 0)) {
      return navigate('/registration-form');
    }
  }
  useEffect(() => {
    checkRegisteration();
  }, []);

  return (
    <>
        {
          props.children
        }
    </>
  )
}
